import { render, staticRenderFns } from "./ManagerInviteList.vue?vue&type=template&id=7c135318&"
import script from "./ManagerInviteList.vue?vue&type=script&lang=js&"
export * from "./ManagerInviteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports